import './contentBlockStyles.css'
import NormalText from "../text/normalText";
import H3Title from '../text/h3Title/h3Title';

export default function ContentBlock({title="", text, photo="", type=""}) {

    if (type === 'text-right-title-outside') 
        return (
            <div className='content-block__container'>
                
                {title && <H3Title title={title} />}
                <div className="content-block__container-text-right">
                    <div className="content-block__text-block">
                        <NormalText text={text} />
                    </div>
                    {photo && <img className="content-block__small-photo" src={photo} alt="" />}
                </div>

            </div>
        );

    if (type === 'photo-right-title-outside') 
        return (
            <div className='content-block__container'>  
                {title && <H3Title title={title} />}
                <div className="content-block__container-photo-right">
                    <div className="content-block__text-block">
                        <NormalText text={text} />
                    </div>
                    {photo && <img className="content-block__small-photo" src={photo} alt="" />}
                </div>
            </div>
        );
    if (type === 'text-right-title-inside') 
        return (
            <div className="content-block__container-text-right">

                <div className="content-block__text-block">
                    {title && <H3Title title={title} />}
                    <NormalText text={text} />
                </div>
                {photo && <img className="content-block__small-photo" src={photo} alt="" />}

            </div>
        );

    if (type === 'photo-right-title-inside') 
        return (
            <div className="content-block__container-photo-right">

                <div className="content-block__text-block">
                    {title && <H3Title title={title} />}
                    <NormalText text={text} />
                </div>
                {photo && <img className="content-block__small-photo" src={photo} alt="" />}

            </div>
        );

    return (
        <div className="content-block__container">
            {title && <H3Title title={title} />}
            {photo && <img className="content-block__big-photo" src={photo} alt="" />}
            <NormalText text={text} />    
        </div>
    );

}
